import React from 'react';

const Button = ({ ariaExpanded, ariaLabel, buttonDataId, children, disabled, onClick, titleText, className }) => (
  <button
    aria-expanded={ariaExpanded}
    aria-label={ariaLabel}
    className={className}
    data-id={buttonDataId}
    disabled={disabled}
    onClick={onClick}
    title={titleText}
    type="button"
  >
    {children}
  </button>
);

Button.defaultProps = {
  ariaExpanded: undefined,
  ariaLabel: undefined,
  buttonDataId: undefined,
  disabled: undefined,
  titleText: undefined,
};

export default Button;
